import baseApi from "src/config/api/base"
import { ApplyRequest, ApplyResponse, ResendOtpRequest } from "./types/apply"
import { Apply2Request, Apply2Response } from "./types/apply2"
import { Apply3Request } from "./types/apply3"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetProductInfoRequest, GetProductInfoResponse } from "./types/getProductInfo"
import { GetConfigListRequest, GetConfigListResponse } from "./types/configList"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebCommercialCredit/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebCommercialCredit/RefreshCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getProductInfo: builder.mutation<GetProductInfoResponse, GetProductInfoRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          productType: body.productType,
          term: body.term,
          amount: body.amount,
          NextTransactionUrl: "Facebook/WebCommercialCredit/GetProducts1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getConfigList: builder.mutation<GetConfigListResponse, GetConfigListRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          functionCode: "KRD0002",
          cid: body.cid,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfigListWithFunctionCode1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<ApplyResponse, ApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/WebCommercialCredit/Apply1",
          TokenSessionId: body.TokenSessionId,
          Language: body.Language,
          tckn: body.tckn,
          birthDate: body.birthDate,
          phoneCountryCode: body.phoneCountryCode,
          phoneAreaCode: body.phoneAreaCode,
          phoneNumber: body.phoneNumber,
          kvkk: body.kvkk,
          amount: body.amount,
          term: body.term,
          cid: body.cid,
          captcha: body.captcha,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<BaseResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          Language: body.Language,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebCommercialCredit/ResendOtp1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          otp: body.otp,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebCommercialCredit/Apply2",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3: builder.mutation<BaseResponse, Apply3Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          kimlikSeriSiraNo: body.kimlikSeriSiraNo,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebCommercialCredit/Apply3",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useResendOtpMutation, useApply2Mutation, useApply3Mutation, useGetProductInfoMutation, useGetConfigListMutation } = api

export default api
